export default "__VITE_ASSET__BhE$7B4T__"